var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inline-block"},[_c('a',{staticClass:"break-all",attrs:{"href":_vm.fullUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.shareUrl))]),_c('CopyText',{staticClass:"ml-6",attrs:{"text":_vm.fullUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }